import { React, useState, useContext } from "react";
import AddIcon from "@mui/icons-material/Add";
import "../css/EscortOfficerList.css";
import Modal from "../../../components/elements/Modal";
import {
  ClearanceStatus as Status,
  TRIP_PHASE,
} from "../../../utils/constants";
import AddOfficerModal from "../../../components/elements/AddOfficerModal";
import { StorageContext } from "../../../services/StorageProvider";
import { useFormData } from "../../../helper/FormDataProvider";
import { hasAirportAccess } from "../../../utils/Utils";
import deleteIcon from "../../../assets/images/delete_icon.svg";
import DeleteModal from "../../../components/elements/DeleteModal";
import editIcon from "../../../assets/images/edit_icon.svg";

const EscortArrivalOfficersList = ({
  officers = [],
  onAddOfficer,
  onEditOfficer,
  onDeleteOfficer,
  clearanceStatus,
  airportId,
}) => {
  const { userData } = useFormData();
  const { airportData } = useContext(StorageContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [officerToDelete, setOfficerToDelete] = useState(null);
  const [editingOfficer, setEditingOfficer] = useState(null);

  // Check if user has access to the arrival airport
  const hasArrivalAirportAccess = hasAirportAccess(
    userData,
    airportData,
    airportId
  );

  const handleAddOfficeClick = () => {
    setIsModalOpen(true);
  };

  const handleEditClick = (officer, index) => {
    setEditingOfficer({ ...officer, index });
    setIsModalOpen(true);
  };

  const handleDeleteClick = (index) => {
    if (officers.length <= 2) {
      return;
    }
    setOfficerToDelete(index);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteOfficer = () => {
    if (officerToDelete !== null) {
      onDeleteOfficer(officerToDelete);
    }
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };

  const cancelDelete = () => {
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };

  const isApproved =
    clearanceStatus === Status.PAID ||
    clearanceStatus === Status.CLEARANCE_REJECTED ||
    clearanceStatus === Status.CANCELLED ||
    clearanceStatus === Status.CORRECTION_REQUESTED;

  return (
    <div>
      <div className="escort-arrival-officers-list">
        <div className="escort-officers-header">
          <p>Added Officers</p>
          {!isApproved && (
            <button
              className={`escort-add-officer-btn ${!hasArrivalAirportAccess ? 'disabled' : ''}`}
              onClick={hasArrivalAirportAccess ? handleAddOfficeClick : undefined}
              disabled={!hasArrivalAirportAccess}
              data-testid="arrival-add-officer-btn"
            >
              <AddIcon />
              Add Officer
            </button>
          )}
        </div>
        <div className="escort-officers-box" data-testid="arrival-officers-box">
          {officers.length > 0 ? (
            officers.map((officer, index) => (
              <div className="escort-officer" key={index} data-testid="arrival-officer">
                <div className="escort-officer-details">
                  <p>
                    {officer.name} - {officer.hoursWorked} hrs
                  </p>
                </div>
                {!isApproved && hasArrivalAirportAccess && (
                  <div className="escort-officer-actions">
                    <img
                      className="escort-edit-icon"
                      src={editIcon}
                      alt="edit icon"
                      onClick={() => handleEditClick(officer, index)}
                      data-testid={`arrival-edit-icon-${index}`}
                    />
                    {officers.length > 2 && (
                      <img
                        className="escort-delete-icon"
                        src={deleteIcon}
                        alt="delete icon"
                        onClick={() => handleDeleteClick(index)}
                        data-testid={`arrival-delete-icon-${index}`}
                      />
                    )}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="no-officers-message">No officers added</p>
          )}
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => {
        setIsModalOpen(false);
        setEditingOfficer(null);
      }}>
        <AddOfficerModal
          tripPhase={TRIP_PHASE.ARRIVAL}
          onAddOfficer={(updatedOfficer) => {
            if (editingOfficer) {
              onEditOfficer(editingOfficer.index, updatedOfficer[0]);
            } else {
              onAddOfficer(updatedOfficer);
            }
          }}
          onClose={() => {
            setIsModalOpen(false);
            setEditingOfficer(null);
          }}
          airportId={airportId}
          existingOfficers={officers.filter((_, i) =>
            editingOfficer ? i !== editingOfficer.index : true
          )}
          editingOfficer={editingOfficer}
        />
      </Modal>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={cancelDelete}
        onDelete={confirmDeleteOfficer}
      />
    </div>
  );
};

export default EscortArrivalOfficersList;
